<div class="reset-password-container">
  <!-- Left side - Background -->
  <div class="reset-password-left">
  </div>
  
  <!-- Right side - Reset Password Card -->
  <div class="reset-password-right">
    <div class="reset-password-form-container">
   <div class="form-branding">
        <img src="/images/DSDN_Images/desimonelogoblack.png" alt="DeSimone" style="display:block;margin:0 auto 18px auto;max-width:220px;width:100%;height:auto;">
       <h1 class="login-titleh1">STRUCTURAL<br>DETAILER<br>NETWORK</h1>
      </div>
      
      <!-- Reset Password Form -->
      <div *ngIf="!success" class="reset-password-content">
        <h2 class="reset-password-title">Reset Password</h2>
        <p class="reset-password-description">
          Enter your new password below.
        </p>

        <!-- Validating Token Message -->
        <div *ngIf="validatingToken" class="info-message">
          <span>Verifying reset link...</span>
        </div>

        <form (ngSubmit)="onSubmit()" class="reset-password-form">
          <!-- New Password Field -->
          <div class="form-group">
            <label for="newPassword" class="form-label">New Password</label>
            <div class="password-input-wrapper">
              <input 
                [type]="showPassword ? 'text' : 'password'"
                id="newPassword"
                name="newPassword"
                [(ngModel)]="newPassword"
                class="form-control"
                placeholder="Enter new password"
                required
                [disabled]="loading || validatingToken || tokenInvalid"
              >
              <button 
                type="button"
                class="password-toggle"
                (click)="togglePasswordVisibility()"
                [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
              >
                <svg *ngIf="!showPassword" class="eye-icon" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M10 12a2 2 0 100-4 2 2 0 000 4z"/>
                  <path fill-rule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clip-rule="evenodd"/>
                </svg>
                <svg *ngIf="showPassword" class="eye-icon" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M3.707 2.293a1 1 0 00-1.414 1.414l14 14a1 1 0 001.414-1.414l-1.473-1.473A10.014 10.014 0 0019.542 10C18.268 5.943 14.478 3 10 3a9.958 9.958 0 00-4.512 1.074l-1.78-1.781zm4.261 4.26l1.514 1.515a2.003 2.003 0 012.45 2.45l1.514 1.514a4 4 0 00-5.478-5.478z" clip-rule="evenodd"/>
                  <path d="M12.454 16.697L9.75 13.992a4 4 0 01-3.742-3.741L2.335 6.578A9.98 9.98 0 00.458 10c1.274 4.057 5.065 7 9.542 7 .847 0 1.669-.105 2.454-.303z"/>
                </svg>
              </button>
            </div>
          </div>

          <!-- Confirm Password Field -->
          <div class="form-group">
            <label for="confirmPassword" class="form-label">Confirm Password</label>
            <div class="password-input-wrapper">
              <input 
                [type]="showConfirmPassword ? 'text' : 'password'"
                id="confirmPassword"
                name="confirmPassword"
                [(ngModel)]="confirmPassword"
                class="form-control"
                placeholder="Confirm new password"
                required
                [disabled]="loading || validatingToken || tokenInvalid"
              >
              <button 
                type="button"
                class="password-toggle"
                (click)="toggleConfirmPasswordVisibility()"
                [attr.aria-label]="showConfirmPassword ? 'Hide password' : 'Show password'"
              >
                <svg *ngIf="!showConfirmPassword" class="eye-icon" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M10 12a2 2 0 100-4 2 2 0 000 4z"/>
                  <path fill-rule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clip-rule="evenodd"/>
                </svg>
                <svg *ngIf="showConfirmPassword" class="eye-icon" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M3.707 2.293a1 1 0 00-1.414 1.414l14 14a1 1 0 001.414-1.414l-1.473-1.473A10.014 10.014 0 0019.542 10C18.268 5.943 14.478 3 10 3a9.958 9.958 0 00-4.512 1.074l-1.78-1.781zm4.261 4.26l1.514 1.515a2.003 2.003 0 012.45 2.45l1.514 1.514a4 4 0 00-5.478-5.478z" clip-rule="evenodd"/>
                  <path d="M12.454 16.697L9.75 13.992a4 4 0 01-3.742-3.741L2.335 6.578A9.98 9.98 0 00.458 10c1.274 4.057 5.065 7 9.542 7 .847 0 1.669-.105 2.454-.303z"/>
                </svg>
              </button>
            </div>
          </div>

          <!-- Error Message -->
          <div *ngIf="error" class="error-message">
            <svg class="error-icon" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/>
            </svg>
            {{ error }}
          </div>

          <!-- Submit Button -->
          <button 
            type="submit"
            class="btn-reset-password" 
            [disabled]="loading || validatingToken || !token || tokenInvalid"
          >
            <span *ngIf="!loading">Reset Password</span>
            <span *ngIf="loading" class="loading-content">
              <svg class="spinner-icon" viewBox="0 0 24 24">
                <circle class="spinner-circle" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" fill="none"/>
              </svg>
              Resetting...
            </span>
          </button>

          <!-- Back to Login Link -->
          <a class="back-to-login-link" (click)="backToLogin()">
            <svg class="back-icon" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clip-rule="evenodd"/>
            </svg>
            Back to Login
          </a>
        </form>
      </div>

      <!-- Success Message -->
      <div *ngIf="success" class="success-content">
        <div class="success-icon-container">
          <svg class="success-icon" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
          </svg>
        </div>
        
        <h2 class="success-title">Password Reset Successfully</h2>
        <p class="success-description">
          Your password has been reset. You can now log in with your new password.
        </p>

        <button class="btn-back-login" (click)="backToLogin()">
          Go to Login
        </button>
      </div>
    </div>
  </div>
</div>
